import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import ImageWithBasePath from "../../../core/common/imageWithBasePath";
import { activeList} from "../../../core/common/selectoption/selectoption";
import Select from "react-select";
import DatePicker from "react-datepicker";
import CollapseHeader from "../../../core/common/collapse-header";
import { useTranslation } from "react-i18next";
import { createTask } from "../../../api/api";
import { fetchUser } from "../../../api/api";
import { fetchTasks ,updateTask,deleteTask,fetchBillNoAndPartyName,updateTaskStatus} from "../../../api/api";
import { usePrivileges } from "../../../core/context/PrivilegeContext";
import dayjs from "dayjs";

//const route = all_routes;
const Task = () => {
  const { privileges } = usePrivileges();
  const { t } = useTranslation();
  const [tasks, setTasks] = useState<any[]>([]); //stores all tasks from backend to display in UI
   const [users, setUsers] = useState([]);

   const [editingTask, setEditingTask] = useState<any>(null);// for updating task (stores task data when edit button is clicked to prefill the form)  
   const [deleteId, setDeleteId] = useState<number | null>(null);
  const [searchTerm, setSearchTerm] = useState("");

  const [selectedDate, setSelectedDate] = useState<Date | null>(new Date());
  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
  };
  const [selectedDate1, setSelectedDate1] = useState<Date | null>(new Date());
  const handleDateChange1 = (date: Date | null) => {
    setSelectedDate1(date);
  };

  //update status
const [statusTaskId, setStatusTaskId] = useState<number | null>(null);
const [newStatus, setNewStatus] = useState<string>("");
//const [completedDate, setCompletedDate] = useState<Date | null>(null);
 
  //admin privillages 
  const token = localStorage.getItem("token");

let isAdmin = false;

if (token) {
  try {
    const payload = JSON.parse(atob(token.split(".")[1]));
    isAdmin = payload?.isAdmin === true;
  } catch (err) {
    console.error("Invalid token", err);
  }
}

    const meetingMode = [
    { value: "Choose", label: "Choose" },
    { value: "Calls", label: "Calls" },
    { value: "Email", label: "Email" },
    { value: "Meeting", label: "Meeting" },
  ];

   const priorityList = [
  { value: 'Select', label: 'Select', color: '#000' },
  { value: 'High', label: 'High', color: 'red' },
  { value: 'Low', label: 'Low', color: 'blue' },
  { value: 'Medium', label: 'Medium', color: 'orange' },
];

const priorityStyles = {

  option: (base: any, state: any) => {
    let bg = "white";

    switch (state.data.value) {
      case "High":
        bg = state.isSelected ? "#ffe5e5" : "white";
        break;
      case "Low":
        bg = state.isSelected ? "#e5f0ff" : "white";
        break;
      case "Medium":
        bg = state.isSelected ? "#fff4d6" : "white";
        break;
    }

    return {
      ...base,
      backgroundColor: state.isSelected
        ? bg
        : state.isFocused
        ? "#f5f5f5"
        : "white",
      color: "#000", // keep text normal
    };
  },

  singleValue: (base: any) => ({
    ...base,
    color: "#000",
  }),
};

const getPriorityColor = (priority: string) => {
  switch (priority) {
    case "High":
      return "red";
    case "Low":
      return "blue";
    case "Medium":
      return "orange";
    default:
      return "#ccc"; // default grey (NOT red)
  }
};
 
  //filter search task
  const filteredTasks = tasks
  .filter((task) =>
    task.title?.toLowerCase().includes(searchTerm.toLowerCase())
  )
  .sort((a, b) => a.title.localeCompare(b.title));

// DATE HELPERS
//to handle recent yesterday,today taskDatalist 
const formatLocalDate = (dateStr: string) => {
  if (!dateStr) return "";

  // handles BOTH formats safely
  if (dateStr.includes("T")) {
    return dateStr.split("T")[0];
  }

  return dateStr.split(" ")[0];
};

// ALWAYS USE LOCAL DATE
const getLocalDate = (date = new Date()) => {
  return date.getFullYear() + "-" +
    String(date.getMonth() + 1).padStart(2, "0") + "-" +
    String(date.getDate()).padStart(2, "0");
};

// TODAY
const today = getLocalDate();

// YESTERDAY
const yDate = new Date();
yDate.setDate(yDate.getDate() - 1);
const yesterday = getLocalDate(yDate);

// FILTER TASKS
const todayTasks = filteredTasks.filter(
  (t) => t.start_date && formatLocalDate(t.start_date) === today
);

const yesterdayTasks = filteredTasks.filter(
  (t) => t.start_date && formatLocalDate(t.start_date) === yesterday
);
// FORMAT DATE FOR API (SAVE)
const formatDateTimeLocal = (date: Date | null) => {
  if (!date) return null;

  return date.getFullYear() + "-" +
    String(date.getMonth() + 1).padStart(2, "0") + "-" +
    String(date.getDate()).padStart(2, "0") + " " +
    String(date.getHours()).padStart(2, "0") + ":" +
    String(date.getMinutes()).padStart(2, "0") + ":" +
    String(date.getSeconds()).padStart(2, "0");
};

//to get tasks of last 2 and 3 days (for yesterday and today section in UI)
// 2 days ago
const twoDaysDate = new Date();
twoDaysDate.setDate(twoDaysDate.getDate() - 2);
const twoDaysAgo = getLocalDate(twoDaysDate);

// 3 days ago
const threeDaysDate = new Date();
threeDaysDate.setDate(threeDaysDate.getDate() - 3);
const threeDaysAgo = getLocalDate(threeDaysDate);

// FILTER
const twoDaysAgoTasks = filteredTasks.filter(
  (t) => t.start_date && formatLocalDate(t.start_date) === twoDaysAgo
);

const threeDaysAgoTasks = filteredTasks.filter(
  (t) => t.start_date && formatLocalDate(t.start_date) === threeDaysAgo
);

 const [billDetails, setBillDetails] = useState<any[]>([]); //get billno.billpartyname for dropdown in create task form
 
 useEffect(() => {
  const loadBills = async () => {
    try {
      const data = await fetchBillNoAndPartyName();

      console.log("Bills:", data);

      setBillDetails(data);

    } catch (err) {
      console.error(err);
    }
  };

  loadBills();
}, []);

 //to fetch users (dropdown in create task).
 useEffect(() => {
  const getUsers = async () => {
    try {
      const data = await fetchUser();
      console.log("Users:", data); 
      setUsers(data);
    } catch (err) {
      console.error(err);
    }
  };

  getUsers();
}, []);

//fetch tasks for displaying 
const loadTasks = async () => {
  try {
    const data = await fetchTasks();
    console.log("Tasks:", data);
    setTasks(data);
  } catch (err) {
    console.error(err);
  }
};

useEffect(() => {
  loadTasks();
}, []);

const [formData, setFormData] = useState({
  title: "",
  bill_no: "",
  category: "",
  task_holder: "", 
  start_date: "",
  due_date: "",
  tags: "",
  priority: "",
  status: "",
  description: ""
});

const handleChange = (name: string, value: any) => {
  setFormData((prev) => ({
    ...prev,
    [name]: value
  }));
};

const handleSubmit = async (e: React.FormEvent) => {
  e.preventDefault();

  if (!isAdmin && !privileges?.includes("create_task")) {
    alert(t("noPermissionCreateTask"));
    return;
  }

  // FIND SELECTED BILL
  const selectedBill = billDetails.find(
    (bill: any) =>
      String(bill.BillNo) === String(formData.bill_no)
  );

  // TITLE TEXT
  const titleText = formData.title.trim();

  // IF BOTH TITLE + DROPDOWN ARE FILLED
  // ALERT ONLY WHEN THEY ARE DIFFERENT
  if (
    titleText &&
    selectedBill &&
    !titleText.includes(String(selectedBill.BillNo))
  ) {
    alert(t("chooseOnlyOne"));
    return;
  }

  // FINAL TITLE
  const finalTitle = selectedBill
    ? `${selectedBill.BillNo} - ${selectedBill.BillPartyName}`
    : titleText;

  const payload = {
    ...formData,
    status: formData.status || "Active",
    title: finalTitle,
    start_date: formatDateTimeLocal(selectedDate),
    due_date: formatDateTimeLocal(selectedDate1),
  };

  try {
    const res = await createTask(payload);

    console.log(res);

    alert(t("taskCreatedSuccess"));

    // REFRESH TASK LIST
    await loadTasks();

    // RESET FORM
    setFormData({
      title: "",
      bill_no: "",
      category: "",
      task_holder: "",
      start_date: "",
      due_date: "",
      tags: "",
      priority: "",
      status: "",
      description: ""
    });

    // RESET DATE
    setSelectedDate(new Date());
    setSelectedDate1(new Date());

    // CLOSE MODAL
    const offcanvasEl = document.getElementById("offcanvas_add");

    if (offcanvasEl) {
      offcanvasEl.classList.remove("show");
      offcanvasEl.setAttribute("aria-hidden", "true");
      offcanvasEl.removeAttribute("aria-modal");

      const backdrop = document.querySelector(".offcanvas-backdrop");

      if (backdrop) backdrop.remove();

      document.body.classList.remove("offcanvas-backdrop");
      document.body.style.overflow = "";
    }

 } catch (err: any) {
  console.error(err);

  // Backend validation message
  const errorMessage =
    err?.response?.data?.message ||
    err?.response?.data?.error ||
    err?.response?.data ||
    t("taskCreateFailed");

  alert(errorMessage);
}
};

//to prefill the update form when edit button is clicked from task list
const handleEditClick = (task: any) => {
  setEditingTask(task);
  console.log("Original start_date:", task.start_date);

  setFormData({
    title: task.title || "",
    bill_no: task.bill_no || "",
    category: task.category || "",
    task_holder: task.task_holder || "",
    start_date: task.start_date || "",
    due_date: task.due_date || "",
    tags: task.tags || "",
    priority: task.priority || "",
    status: task.status || "",
    description: task.description || ""
  });

  // set date pickers
  const parseUTCToLocal = (dateStr: string) => {
  if (!dateStr) return null;

  const d = new Date(dateStr); // UTC → auto converts to local
  return new Date(
    d.getFullYear(),
    d.getMonth(),
    d.getDate(),
    d.getHours(),
    d.getMinutes(),
    d.getSeconds()
  );
};
  setSelectedDate(parseUTCToLocal(task.start_date));
  setSelectedDate1(parseUTCToLocal(task.due_date));
};

//editing and saving updated task
const handleUpdate = async (e: React.FormEvent) => {
  e.preventDefault();
  
  if (!isAdmin && !privileges?.includes("update_task")) {
 alert(t("noPermissionUpdateTask"));
  return;
}
 if (!editingTask) return;

 const payload = {
  ...formData,
  start_date: selectedDate ? formatDateTimeLocal(selectedDate) : null,
due_date: selectedDate1 ? formatDateTimeLocal(selectedDate1) : null,
};
console.log("Updating start_date:", payload.start_date);
  try {
    await updateTask(editingTask.tid, payload);

  alert(t("taskUpdatedSuccess"));

    setEditingTask(null);

    // reset AFTER success
    setFormData({
      title: "",
      bill_no: "",
      category: "",
      task_holder: "",
      start_date: "",
      due_date: "",
      tags: "",
      priority: "",
      status: "",
      description: ""
    });

    await loadTasks(); // refresh list
    
    const offcanvasEl = document.getElementById("offcanvas_edit");

if (offcanvasEl) {
  offcanvasEl.classList.remove("show");
  offcanvasEl.setAttribute("aria-hidden", "true");
  offcanvasEl.removeAttribute("aria-modal");

  const backdrop = document.querySelector(".offcanvas-backdrop");
  if (backdrop) backdrop.remove();

  document.body.classList.remove("offcanvas-backdrop");
  document.body.style.overflow = "";
}

  } catch (err) {
    console.error(err);
    alert(t("taskUpdateFailed"));
  }
};

//delete task
const handleDelete = async () => {

   if (!isAdmin && !privileges?.includes("delete_task")) {
  alert(t("noPermissionDeleteTask"));
  return;
}

  if (!deleteId) return;

  try {
    await deleteTask(deleteId);

    alert(t("taskDeletedSuccess"));

    setDeleteId(null);      // reset
    await loadTasks();      // refresh UI

  } catch (err) {
    console.error(err);
   alert(t("task_delete_failed"));
  }
};

//update task status 
// update task status
const handleStatusUpdate = async () => {
  if (!statusTaskId || !newStatus) return;

  if (!isAdmin && !privileges?.includes("update_task")) {
    alert(t("noPermissionUpdateTaskStatus"));
    return;
  }

  // SAVE ONLY DATE
  const systemCompletedDate =
    newStatus === "Completed"
      ? dayjs().format("YYYY-MM-DD")
      : null;

  try {
    await updateTaskStatus(
      statusTaskId,
      newStatus,
      systemCompletedDate
    );

    alert(t("statusUpdatedSuccessfully"));

    setTasks((prev) =>
      prev.map((task) =>
        task.tid === statusTaskId
          ? {
              ...task,
              status: newStatus,
              completed_date: systemCompletedDate,
            }
          : task
      )
    );

    setStatusTaskId(null);
    setNewStatus("");

    // refresh from DB too
    await loadTasks();

  } catch (err) {
    console.error(err);
    alert(t("failedToUpdateStatus"));
  }
};

return (
    <>
      {/* Page Wrapper */}
      <div className="page-wrapper">
        <div className="content">

          <div className="row">
            <div className="col-md-12">
              {/* Page Header */}
              <div className="page-header">
                <div className="row align-items-center">
                  <div className="col-4">
                    <h4 className="page-title">
                      {t("tasks")}<span className="count-title">123</span>
                    </h4>
                  </div>
                  <div className="col-8 text-end">
                    <div className="head-icons">
                      <CollapseHeader />
                    </div>
                  </div>
                </div>
              </div>
              {/* /Page Header */}
              <div className="card">
                <div className="card-header">
                  {/* Search */}
                  <div className="row align-items-center">
                    <div className="col-sm-4">
                      <div className="icon-form mb-sm-0">
                        <span className="form-icon">
                          <i className="ti ti-search" />
                        </span>
                       <input
                        type="text"
                        className="form-control"
                        placeholder={t("searchTask")}
                        value={searchTerm} 
                        onChange={(e) => setSearchTerm(e.target.value)}
                      />
                      </div>
                    </div>
                    <div className="col-sm-8">
                      <div className="d-flex align-items-center flex-wrap row-gap-2 justify-content-sm-end mb-3 mb-sm-0">
                        <Link
                          to="#"
                          className="btn btn-primary"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#offcanvas_add"
                        >
                          <i className="ti ti-square-rounded-plus me-2" />
                          {t("addNewTask")}
                        </Link>
                      </div>
                    </div>
                  </div>
                  {/* /Search */}
                </div>

                <div className="card-body">
                  <>
                    {/* Filter */}
                    {/* <div className="d-flex align-items-center justify-content-between flex-wrap row-gap-2 mb-4">
                      <div className="sort-dropdown drop-down task-drops">
                        <Link
                          to="#"
                          className="dropdown-toggle"
                          data-bs-toggle="dropdown"
                        >
                          All Tasks{" "}
                        </Link>
                        <div className="dropdown-menu  dropdown-menu-start">
                          <ul>
                            <li>
                              <Link to={route.tasks}>
                                <i className="ti ti-dots-vertical" />
                                All Tasks
                              </Link>
                            </li>
                            <li>
                              <Link to={route.tasksImportant}>
                                <i className="ti ti-dots-vertical" />
                                Important
                              </Link>
                            </li>
                            <li>
                              <Link to={route.tasksCompleted}>
                                <i className="ti ti-dots-vertical" />
                                Completed
                              </Link>
                            </li>
                          </ul>
                        </div>
                      </div>
                      <div className="d-flex align-items-center flex-wrap row-gap-2">
                       
                        
                        <div className="icon-form me-2">
                          <span className="form-icon">
                            <i className="ti ti-calendar" />
                          </span>
                          <DateRangePicker initialSettings={initialSettings}>
                                                            <input
                                                                className="form-control bookingrange"
                                                                type="text"
                                                            />
                                                        </DateRangePicker>
                        </div>
                        <div className="form-sorts dropdown">
                          <Link
                            to="#"
                            data-bs-toggle="dropdown"
                            data-bs-auto-close="outside"
                          >
                            <i className="ti ti-filter-share" />
                            Filter
                          </Link>
                          <div className="filter-dropdown-menu dropdown-menu  dropdown-menu-md-end p-3">
                            <div className="filter-set-view">
                              <div className="filter-set-head">
                                <h4>
                                  <i className="ti ti-filter-share" />
                                  Filter
                                </h4>
                              </div>
                              <div className="accordion" id="accordionExample">
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link
                                      to="#"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseTwo"
                                      aria-expanded="true"
                                      aria-controls="collapseTwo"
                                    >
                                      Task Name
                                    </Link>
                                  </div>
                                  <div
                                    className="filter-set-contents accordion-collapse collapse show"
                                    id="collapseTwo"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Task"
                                        />
                                      </div>
                                      <ul>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input
                                                type="checkbox"
                                                 defaultChecked
                                              />
                                              <span className="checkmarks" />
                                              Add a form to Update Task
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              Add a form to Update Task
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              Update orginal content
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              Use only component colours
                                            </label>
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link
                                      to="#"
                                      className="collapsed"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#owner"
                                      aria-expanded="false"
                                      aria-controls="owner"
                                    >
                                      Task Type
                                    </Link>
                                  </div>
                                  <div
                                    className="filter-set-contents accordion-collapse collapse"
                                    id="owner"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="filter-content-list">
                                      <div className="mb-2 icon-form">
                                        <span className="form-icon">
                                          <i className="ti ti-search" />
                                        </span>
                                        <input
                                          type="text"
                                          className="form-control"
                                          placeholder="Search Client"
                                        />
                                      </div>
                                      <ul>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input
                                                type="checkbox"
                                                 defaultChecked
                                              />
                                              <span className="checkmarks" />
                                              Meeting
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              Calls
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              Task
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              Email
                                            </label>
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link
                                      to="#"
                                      className="collapsed"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseone"
                                      aria-expanded="false"
                                      aria-controls="collapseone"
                                    >
                                      Tags
                                    </Link>
                                  </div>
                                  <div
                                    className="filter-set-contents accordion-collapse collapse"
                                    id="collapseone"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="filter-content-list">
                                      <ul>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input
                                                type="checkbox"
                                                 defaultChecked
                                              />
                                              <span className="checkmarks" />
                                              Collab
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              Rated
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              Promotion
                                            </label>
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link
                                      to="#"
                                      className="collapsed"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapseThree"
                                      aria-expanded="false"
                                      aria-controls="collapseThree"
                                    >
                                      Created By
                                    </Link>
                                  </div>
                                  <div
                                    className="filter-set-contents accordion-collapse collapse"
                                    id="collapseThree"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="filter-content-list">
                                      <ul>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input
                                                type="checkbox"
                                                 defaultChecked
                                              />
                                              <span className="checkmarks" />
                                              Hendry
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              Monty Beer
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              Bradtke
                                            </label>
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                                <div className="filter-set-content">
                                  <div className="filter-set-content-head">
                                    <Link
                                      to="#"
                                      className="collapsed"
                                      data-bs-toggle="collapse"
                                      data-bs-target="#collapsethree"
                                      aria-expanded="false"
                                      aria-controls="collapsethree"
                                    >
                                      Created Date
                                    </Link>
                                  </div>
                                  <div
                                    className="filter-set-contents accordion-collapse collapse"
                                    id="collapsethree"
                                    data-bs-parent="#accordionExample"
                                  >
                                    <div className="filter-content-list">
                                      <ul>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input
                                                type="checkbox"
                                                 defaultChecked
                                              />
                                              <span className="checkmarks" />
                                              23 Oct 2023
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              29 Sep 2023
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              24 Oct 2023
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                              25 Oct 2023
                                            </label>
                                          </div>
                                        </li>
                                        <li>
                                          <div className="filter-checks">
                                            <label className="checkboxs">
                                              <input type="checkbox" />
                                              <span className="checkmarks" />
                                            </label>
                                          </div>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                              <div className="filter-reset-btns">
                                <div className="row">
                                  <div className="col-6">
                                    <Link to="#" className="btn btn-light">
                                      Reset
                                    </Link>
                                  </div>
                                  <div className="col-6">
                                    <Link
                                      to={route.tasks}
                                      className="btn btn-primary"
                                    >
                                      Filter
                                    </Link>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}
                    {/* /Filter */}
                  </>

                  {/* Recent Task List */}
                  <div className="task-wrapper">
                    <Link
                      to="#"
                      className="task-accordion"
                      data-bs-toggle="collapse"
                      data-bs-target="#recent"
                    >
                     <h4>
                     {t("today")} <span>{todayTasks.length}</span>
                    </h4>
                    </Link>
                    <div
                      className="tasks-activity tasks collapse show"
                      id="recent"
                    >
                     <ul>
                      {todayTasks.map((task: any, index: number) => (
                        <li key={task.tid || index} className="task-wrap pending">
                          <div className="task-info">
                            <span className="task-icon">
                              <i className="ti ti-grip-vertical" />
                            </span>

                            <div className="task-checkbox">
                              <label className="checkboxs">
                                <input type="checkbox" />
                                <span className="checkmarks" />
                              </label>
                            </div>

                            <div className="set-star rating-select">
                              <i className="fa fa-star" />
                            </div>

                            <p>{task.title}</p>

                            <span className="badge badge-pill badge-status bg-green">
                              {task.category}
                            </span>

                            <span className={`badge badge-tag ${
                              task.status === "Pending"
                                ? "bg-pending"
                                : task.status === "Inprogress"
                                ? "bg-warning"
                                : "bg-success"
                            }`}>
                              {task.status}
                            </span>
                          </div>

                          <div className="task-actions">
                            <ul>
                              <li className="task-date">
                                <i className="ti ti-calendar-exclamation" />
                               {formatLocalDate(task.due_date)}
                              </li>

                              <li className="task-owner">
                                <div className="task-user">
                                  <ImageWithBasePath
                                    src="assets/img/profiles/avatar-14.jpg"
                                    alt="img"
                                  />
                                </div>

                                <div className="dropdown table-action">
                                  <Link
                                    to="#"
                                    className="action-icon"
                                    data-bs-toggle="dropdown"
                                  >
                                    <i className="fa fa-ellipsis-v" />
                                  </Link>

                                  <div className="dropdown-menu dropdown-menu-right">
                                    <Link
                                        className="dropdown-item"
                                        data-bs-toggle="offcanvas"
                                        to="#"
                                        data-bs-target="#offcanvas_edit"
                                        onClick={() => handleEditClick(task)}
                                      >
                                      <i className="ti ti-edit text-blue"></i>{t("edit")}
                                    </Link>

                                    <Link
                                    className="dropdown-item"
                                    to="#"
                                    data-bs-toggle="modal"
                                    data-bs-target="#status_update_modal"
                                  onClick={() => {
                                    setStatusTaskId(task.tid);
                                    setNewStatus(task.status || "");
                                  }}
                                  >
                                    <i className="ti ti-refresh text-warning"></i> {t("updateStatus")}
                                  </Link>

                                    <Link
                                    className="dropdown-item"
                                    to="#"
                                    data-bs-toggle="modal"
                                    data-bs-target="#delete_activity"
                                    onClick={() => setDeleteId(task.tid)}   
                                  >
                                    <i className="ti ti-trash text-danger" /> {t("delete")}
                                  </Link>

                              

                                  </div>
                                </div>
                              </li>
                            </ul>
                          </div>
                        </li>
                      ))}
                    </ul>
                    </div>
                  </div>
                  {/* /Recent Task List */}
                  {/* Task List */}
                  <div className="task-wrapper">
                    <Link
                      to="#"
                      className="task-accordion"
                      data-bs-toggle="collapse"
                      data-bs-target="#yesterday"
                    >
                      <h4>{t("yesterday")}</h4>
                    </Link>
                    <div
                      className="tasks-activity tasks collapse show"
                      id="yesterday"
                    >
                      <ul>
                        {yesterdayTasks.length === 0 ? (
                          <p className="text-muted">{t("noTasks")}</p>
                        ) : (
                          yesterdayTasks.map((task, index) => (
                            <li key={task.tid || index} className="task-wrap warning">
                              <div className="task-info">
                                <span className="task-icon">
                                  <i className="ti ti-grip-vertical" />
                                </span>

                                <div className="task-checkbox">
                                  <label className="checkboxs">
                                    <input type="checkbox" />
                                    <span className="checkmarks" />
                                  </label>
                                </div>

                                <div className="set-star rating-select">
                                  <i className="fa fa-star" />
                                </div>

                                <p>{task.title}</p>

                                <span className="badge badge-pill badge-status bg-green">
                                  {task.category}
                                </span>

                                <span className={`badge badge-tag ${
                                  task.status === "Pending"
                                    ? "bg-pending"
                                    : task.status === "Inprogress"
                                    ? "bg-warning"
                                    : "bg-success"
                                }`}>
                                  {task.status}
                                </span>
                              </div>

                              <div className="task-actions">
                                <ul>
                                  <li className="task-date">
                                    <i className="ti ti-calendar-exclamation" />
                                    {formatLocalDate(task.due_date)}
                                  </li>

                                  <li className="task-owner">
                                    <div className="task-user">
                                      <ImageWithBasePath
                                        src="assets/img/profiles/avatar-14.jpg"
                                        alt="img"
                                      />
                                    </div>

                                    <div className="dropdown table-action">
                                      <Link
                                        to="#"
                                        className="action-icon"
                                        data-bs-toggle="dropdown"
                                      >
                                        <i className="fa fa-ellipsis-v" />
                                      </Link>

                                      <div className="dropdown-menu dropdown-menu-right">
                                        <Link
                                        className="dropdown-item"
                                        data-bs-toggle="offcanvas"
                                        to="#"
                                        data-bs-target="#offcanvas_edit"
                                        onClick={() => handleEditClick(task)}
                                      >
                                         <i className="ti ti-edit text-blue"></i> {t("edit")}
                                        </Link>
                                        <Link
                                        className="dropdown-item"
                                        to="#"
                                        data-bs-toggle="modal"
                                        data-bs-target="#status_update_modal"
                                        onClick={() => {
                                          setStatusTaskId(task.tid);
                                          setNewStatus(task.status || "");
                                          // setCompletedDate(
                                          //   task.completed_date ? new Date(task.completed_date) : null
                                          // );
                                        }}
                                      >
                                        <i className="ti ti-refresh text-warning"></i> Update Status
                                      </Link>
                                        <Link
                                        className="dropdown-item"
                                        to="#"
                                        data-bs-toggle="modal"
                                        data-bs-target="#delete_activity"
                                        onClick={() => setDeleteId(task.tid)}   
                                      >
                                        <i className="ti ti-trash text-danger" /> {t("delete")}
                                      </Link>
                                      </div>
                                    </div>
                                  </li>
                                </ul>
                              </div>
                            </li>
                          ))
                        )}
                      </ul>
                    </div>
                  </div>
                  {/* /Task List */}
                  {/* Task List */}
                 <div className="task-wrapper">
                  <Link
                    to="#"
                    className="task-accordion"
                    data-bs-toggle="collapse"
                    data-bs-target="#date-03"
                  >
                    <h4>
                      {new Date(twoDaysAgo).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </h4>
                  </Link>

                    <div
                      className="tasks-activity tasks collapse show"
                      id="date-03"
                    >
                      <ul>
                        {twoDaysAgoTasks.length === 0 ? (
                          <p className="text-muted">{t("noTasks")}</p>
                        ) : (
                          twoDaysAgoTasks.map((task: any, index: number) => (
                            <li key={task.tid || index} className="task-wrap warning">
                              <div className="task-info">
                                <span className="task-icon">
                                  <i className="ti ti-grip-vertical" />
                                </span>

                                <div className="task-checkbox">
                                  <label className="checkboxs">
                                    <input type="checkbox" />
                                    <span className="checkmarks" />
                                  </label>
                                </div>

                                <div className="set-star rating-select">
                                  <i className="fa fa-star" />
                                </div>

                                <p>{task.title}</p>

                                <span className="badge badge-pill badge-status bg-green">
                                  {task.category}
                                </span>

                                <span className={`badge badge-tag ${
                                  task.status === "Pending"
                                    ? "bg-pending"
                                    : task.status === "Inprogress"
                                    ? "bg-warning"
                                    : "bg-success"
                                }`}>
                                  {task.status}
                                </span>
                              </div>

                              <div className="task-actions">
                                <ul>
                                  <li className="task-date">
                                    <i className="ti ti-calendar-exclamation" />
                                    {formatLocalDate(task.due_date)}
                                  </li>
                                </ul>
                              </div>
                            </li>
                          ))
                        )}
                      </ul>
                    </div>
                  </div>
                  {/* /Task List */}
                  {/* Task List */}
                  <div className="task-wrapper">
                  <Link
                    to="#"
                    className="task-accordion"
                    data-bs-toggle="collapse"
                    data-bs-target="#date-04"
                  >
                    <h4>
                      {new Date(threeDaysAgo).toLocaleDateString("en-GB", {
                        day: "2-digit",
                        month: "short",
                        year: "numeric",
                      })}
                    </h4>
                  </Link>

                    <div
                      className="tasks-activity tasks collapse show"
                      id="date-04"
                    >
                      <ul>
                        {threeDaysAgoTasks.length === 0 ? (
                          <p className="text-muted">{t("noTasks")}</p>
                        ) : (
                          threeDaysAgoTasks.map((task: any, index: number) => (
                            <li key={task.tid || index} className="task-wrap success">
                              <div className="task-info">
                                <span className="task-icon">
                                  <i className="ti ti-grip-vertical" />
                                </span>

                                <div className="task-checkbox">
                                  <label className="checkboxs">
                                    <input type="checkbox" />
                                    <span className="checkmarks" />
                                  </label>
                                </div>

                                <div className="set-star rating-select">
                                  <i className="fa fa-star" />
                                </div>

                                <p>{task.title}</p>

                                <span className="badge badge-pill badge-status bg-green">
                                  {task.category}
                                </span>

                                <span className={`badge badge-tag ${
                                  task.status === "Pending"
                                    ? "bg-pending"
                                    : task.status === "Inprogress"
                                    ? "bg-warning"
                                    : "bg-success"
                                }`}>
                                  {task.status}
                                </span>
                              </div>

                              <div className="task-actions">
                                <ul>
                                  <li className="task-date">
                                    <i className="ti ti-calendar-exclamation" />
                                    {formatLocalDate(task.due_date)}
                                  </li>
                                </ul>
                              </div>
                            </li>
                          ))
                        )}
                      </ul>
                    </div>
                  </div>
                  {/* /Task List */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
      <>
  {/* Add New Task */}
  <div
    className="offcanvas offcanvas-end offcanvas-large"
    tabIndex={-1}
    id="offcanvas_add"
  >
    <div className="offcanvas-header border-bottom">
      <h4>{t("addNewTask")}</h4>
      <button
        type="button"
        className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      >
        <i className="ti ti-x" />
      </button>
    </div>
    <div className="offcanvas-body">
    <form onSubmit={handleSubmit}>
  <div>
    <div className="row">

      {/* TITLE + TASK DROPDOWN SAME ROW */}
      <div className="col-md-3">
        <div className="mb-3">
          <label className="col-form-label">
            {t("title")} <span className="text-danger">*</span>
          </label>

          <input
            type="text"
            className="form-control"
            value={formData.title}
            onChange={(e) => handleChange("title", e.target.value)}
          />
        </div>
      </div>

      <div className="col-md-9">
        <div className="mb-3">
          <label className="col-form-label">
           {t("task")}
          </label>

          <select
            className="form-control"
            value={formData.bill_no || ""}
            onChange={(e) => handleChange("bill_no", e.target.value)}
          >
            <option value="">-- Clear Selection --</option>

            {billDetails.map((bill: any, index: number) => (
              <option key={index} value={bill.BillNo}>
                {bill.BillNo} - {bill.BillPartyName}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* CATEGORY */}
      <div className="col-md-12">
        <div className="mb-3">
          <label className="col-form-label">
            {t("category")} <span className="text-danger">*</span>
          </label>

          <Select
            options={meetingMode}
            className="select2"
            placeholder={t("choose")}
            value={
              meetingMode.find(
                (opt) => opt.value === formData.category
              ) || null
            }
            onChange={(option: any) =>
              handleChange("category", option ? option.value : "")
            }
          />
        </div>
      </div>

      {/* RESPONSIBLE */}
      <div className="col-md-12">
        <div className="mb-3">
          <label className="col-form-label">
            {t("responsible")} <span className="text-danger">*</span>
          </label>

          <select
            className="form-control"
            value={formData.task_holder}
            onChange={(e) => handleChange("task_holder", e.target.value)}
          >
            <option value="">{t("selectUser")}</option>

            {users.map((user: any) => (
              <option key={user.mid} value={user.Name}>
                {user.Name}
              </option>
            ))}
          </select>
        </div>
      </div>

      {/* START DATE */}
      <div className="col-md-6">
        <label className="col-form-label">
          {t("startDate")} <span className="text-danger">*</span>
        </label>

        <div className="mb-3 icon-form">
          <span className="form-icon">
            <i className="ti ti-calendar-check" />
          </span>

          <DatePicker
            className="form-control"
            selected={selectedDate}
            onChange={(date) => setSelectedDate(date)}
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={15}
            dateFormat="dd-MM-yyyy"
          />
        </div>
      </div>

      {/* DUE DATE */}
      <div className="col-md-6">
        <label className="col-form-label">
          {t("dueDate")} <span className="text-danger">*</span>
        </label>

        <div className="mb-3 icon-form">
          <span className="form-icon">
            <i className="ti ti-calendar-check" />
          </span>

          <DatePicker
            className="form-control"
            selected={selectedDate1}
            onChange={(date) => setSelectedDate1(date)}
            showTimeSelect
            timeFormat="HH:mm"
            timeIntervals={15}
            dateFormat="dd-MM-yyyy"
          />
        </div>
      </div>

      {/* TAGS */}
      <div className="col-md-12">
        <div className="mb-3">
          <label className="col-form-label">
            {t("tags")} <span className="text-danger">*</span>
          </label>

          <input
            className="form-control"
            type="text"
            value={formData.tags}
            onChange={(e) => handleChange("tags", e.target.value)}
          />
        </div>
      </div>

      {/* PRIORITY */}
      <div className="col-md-6">
        <div className="mb-3">
          <label className="col-form-label">
            {t("priority")}
          </label>

          <div
            className="select-priority"
            style={{ position: "relative" }}
          >
            <span
              style={{
                position: "absolute",
                top: "50%",
                left: "10px",
                transform: "translateY(-50%)",
                zIndex: 2,
                pointerEvents: "none",
              }}
            >
              <i
                className="ti ti-square-rounded-filled"
                style={{
                  color: getPriorityColor(formData.priority),
                }}
              />
            </span>

            <Select
              options={priorityList}
              styles={{
                ...priorityStyles,
                control: (base: any) => ({
                  ...base,
                  paddingLeft: "35px",
                }),
              }}
              onChange={(option: any) =>
                handleChange("priority", option?.value)
              }
            />
          </div>
        </div>
      </div>

      {/* STATUS */}
      <div className="col-md-6">
        <div className="mb-3">
          <label className="col-form-label">
            {t("status")}
          </label>

          <Select
            options={activeList}
            onChange={(option: any) =>
              handleChange("status", option?.value)
            }
          />
        </div>
      </div>

      {/* DESCRIPTION */}
      <div className="col-md-12">
        <div className="mb-3">
          <label className="col-form-label">
            {t("description")}
          </label>

          <textarea
            className="form-control"
            value={formData.description}
            onChange={(e) =>
              handleChange("description", e.target.value)
            }
          />
        </div>
      </div>

    </div>
  </div>

  <div className="d-flex align-items-center justify-content-end">
    <button
      type="button"
      data-bs-dismiss="offcanvas"
      className="btn btn-light me-2"
    >
      {t("cancel")}
    </button>

    {(isAdmin || privileges?.includes("create_task")) && (
      <button type="submit" className="btn btn-primary">
        {t("create")}
      </button>
    )}
  </div>
</form>
    </div>
  </div>
  {/* /Add New Task */}
  {/* Edit Task */}
  <div
    className="offcanvas offcanvas-end offcanvas-large"
    tabIndex={-1}
    id="offcanvas_edit"
  >
    <div className="offcanvas-header border-bottom">
     <h4>{t("editTask")}</h4>
      <button
        type="button"
        className="btn-close custom-btn-close border p-1 me-0 d-flex align-items-center justify-content-center rounded-circle"
        data-bs-dismiss="offcanvas"
        aria-label="Close"
      >
        <i className="ti ti-x" />
      </button>
    </div>
    <div className="offcanvas-body">
      <form onSubmit={handleUpdate}>
  <div className="row">

    <div className="col-md-12">
      <div className="mb-3">
        <label className="col-form-label">
         {t("title")} <span className="text-danger">*</span>
        </label>
        <input
          type="text"
          className="form-control"
          value={formData.title}
          onChange={(e) => handleChange("title", e.target.value)}
        />
      </div>

      <div className="mb-3">
        <label className="col-form-label">{t("category")}</label>
        <Select
          options={meetingMode}
          className="select2"
          value={meetingMode.find(opt => opt.value === formData.category)}
          onChange={(opt: any) => handleChange("category", opt?.value)}
        />
      </div>

      <div className="mb-3">
        <label className="col-form-label">
         {t("responsible")} <span className="text-danger">*</span>
        </label>
        {/* <SelectWithImage2
          value={formData.task_holder}
          onChange={(val: any) => handleChange("task_holder", val)}
        /> */}
      </div>
    </div>

    {/* START DATE */}
    <div className="col-md-6">
      <label className="col-form-label">
        {t("startDate")} <span className="text-danger">*</span>
      </label>
      <div className="mb-3 icon-form">
        <span className="form-icon">
          <i className="ti ti-calendar-check" />
        </span>
       <DatePicker
  className="form-control"
  selected={selectedDate}
  onChange={(date) => setSelectedDate(date)}
  showTimeSelect
  timeFormat="HH:mm"
  timeIntervals={15}
  dateFormat="dd-MM-yyyy "
/>
      </div>
    </div>

    {/* DUE DATE */}
    <div className="col-md-6">
      <label className="col-form-label">
        {t("dueDate")} <span className="text-danger">*</span>
      </label>
      <div className="mb-3 icon-form">
        <span className="form-icon">
          <i className="ti ti-calendar-check" />
        </span>
       <DatePicker
  className="form-control"
  selected={selectedDate1}
  onChange={(date) => setSelectedDate1(date)}
  showTimeSelect
  timeFormat="HH:mm"
  timeIntervals={15}
  dateFormat="dd-MM-yyyy"
/>
      </div>
    </div>

    {/* TAGS */}
    <div className="col-md-12">
      <div className="mb-3">
        <label className="col-form-label">{t("tags")}</label>
        <input
          type="text"
          className="form-control"
          value={formData.tags}
          onChange={(e) => handleChange("tags", e.target.value)}
        />
      </div>
    </div>

    {/* PRIORITY */}
    <div className="col-md-6">
      <div className="mb-3">
        <label className="col-form-label">{t("priority")}</label>
        <Select
  options={priorityList}
  styles={priorityStyles}
  value={priorityList.find(opt => opt.value === formData.priority)}
  onChange={(opt: any) => handleChange("priority", opt?.value)}
/>
      </div>
    </div>

    {/* STATUS */}
    {/* <div className="col-md-6">
      <div className="mb-3">
        <label className="col-form-label">{t("status")}</label>
        <Select
          options={activeList}
          value={activeList.find(opt => opt.value === formData.status)}
          onChange={(opt: any) => handleChange("status", opt?.value)}
        />
      </div>
    </div> */}

    {/* DESCRIPTION */}
    <div className="col-md-12">
      <div className="mb-3">
        <label className="col-form-label">{t("description")}</label>
        <textarea
          className="form-control"
          value={formData.description}
          onChange={(e) => handleChange("description", e.target.value)}
        />
      </div>
    </div>

  </div>

  {/* BUTTONS */}
  <div className="d-flex justify-content-end">
    <button
      type="button"
      data-bs-dismiss="offcanvas"
      className="btn btn-light me-2"
    >
      {t("cancel")}
    </button>
{((editingTask && (isAdmin || privileges?.includes("update_task"))) ||
  (!editingTask && (isAdmin || privileges?.includes("create_task")))) && (
  <button type="submit" className="btn btn-primary">
    {editingTask ? t("update") : t("create")}
  </button>
)}
  </div>
</form>
    </div>
  </div>
  {/* /Edit Task */}
  {/* Delete Task */}
  <div className="modal fade" id="delete_activity" role="dialog">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-body">
          <div className="text-center">
            <div className="avatar avatar-xl bg-danger-light rounded-circle mb-3">
              <i className="ti ti-trash-x fs-36 text-danger" />
            </div>
            <h4 className="mb-2">{t("removeTask")}</h4>
            <p className="mb-0">
              {t("confirmDelete")} <br /> {t("taskYouSelected")}.
            </p>
            <div className="d-flex align-items-center justify-content-center mt-4">
               <button
              type="button"
              className="btn btn-light me-2"
              data-bs-dismiss="modal"
              onClick={() => setDeleteId(null)} // optional reset
            >
              {t("cancel")}
            </button>
             <button
  type="button"
  className="btn btn-danger"
  data-bs-dismiss="modal"
  onClick={handleDelete}
 disabled={!isAdmin && !privileges?.includes("delete_task")}
>
  {t("yesDelete")}
</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  {/* /Delete Task */}
  {/* update task status */}
  <div className="modal fade" id="status_update_modal" role="dialog">
  <div className="modal-dialog modal-dialog-centered">
    <div className="modal-content">

      <div className="modal-body text-center">

        <div className="avatar avatar-xl bg-warning-light rounded-circle mb-3">
          <i className="ti ti-refresh fs-36 text-warning" />
        </div>

        <h4 className="mb-3">Update Task Status</h4>

        {/* STATUS */}
        <div className="mb-3 text-start">
          <label className="form-label">Status</label>

          <select
            className="form-control"
            value={newStatus}
            onChange={(e) => setNewStatus(e.target.value)}
          >
            <option value="">Select Status</option>
            <option value="Active">Active</option>
            <option value="In Work">In Work</option>
            <option value="Inactive">Inactive</option>
            <option value="Completed">Completed</option>
          </select>
        </div>

        {/* COMPLETED DATE (ALWAYS VISIBLE) */}
        {/* COMPLETED DATE PREVIEW */}
{/* COMPLETED DATE PREVIEW */}
{newStatus === "Completed" && (
  <div className="mb-3 text-start">
    <label className="form-label">
      Completed Date
    </label>

    <input
      type="text"
      className="form-control"
      value={dayjs().format("DD-MM-YYYY")}
      readOnly
    />
  </div>
)}

        {/* BUTTONS */}
        <div className="d-flex justify-content-center mt-4">

          <button
            type="button"
            className="btn btn-light me-2"
            data-bs-dismiss="modal"
          >
            Cancel
          </button>

          <button
            type="button"
            className="btn btn-primary"
            data-bs-dismiss="modal"
            onClick={handleStatusUpdate}
            disabled={!isAdmin && !privileges?.includes("update_task")}
          >
            Save
          </button>

        </div>

      </div>

    </div>
  </div>
</div>
  {/* update task status */}
  {/* Add New View */}
  <div className="modal custom-modal fade" id="save_view" role="dialog">
    <div className="modal-dialog modal-dialog-centered">
      <div className="modal-content">
        <div className="modal-header">
          <h5 className="modal-title">{t("add_new_view")}</h5>
          <button
            className="btn-close"
            data-bs-dismiss="modal"
            aria-label="Close"
          >
            <i className="ti ti-x" />
          </button>
        </div>
        <div className="modal-body">
          <form >
            <div className="mb-3">
              <label className="col-form-label">{t("view_name")}</label>
              <input type="text" className="form-control" />
            </div>
            <div className="modal-btn text-end">
              <Link to="#" className="btn btn-light" data-bs-dismiss="modal">
                {t("cancel")}
              </Link>
              <button type="submit" className="btn btn-danger">
                {t("save")}
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  {/* /Add New View */}
</>

    </>
  );
};

export default Task;
